import React from 'react';
import { NavLink } from 'react-router-dom';
import { useUser } from '../context';
import { accountSectionsForRole } from './accountPaths';

const navLinkClassName = ({ isActive }: { isActive: boolean }) =>
  `block rounded-xl px-3 py-2 font-sans text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ink/30 ${
    isActive
      ? 'bg-skysoft/50 text-ink shadow-sm ring-2 ring-ink/10'
      : 'text-ink/70 hover:bg-white/80 hover:text-ink'
  }`;

const AccountNav = () => {
  const { user } = useUser();
  const sections = accountSectionsForRole(user?.schoolRole);

  return (
    <nav aria-label="Account sections">
      <ul className="space-y-1">
        {sections.map((section) => (
          <li key={section.id}>
            <NavLink to={section.path} className={navLinkClassName} end>
              {section.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default AccountNav;
